import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { FaGithub, FaLinkedin, FaMedium, FaAws, FaCloud } from 'react-icons/fa';
import { SiGooglecloud } from 'react-icons/si';

const Home = () => {
  const navigate = useNavigate();
  
  const handleNavigation = (path) => {
    if (path !== '/') {
      // For non-home pages, replace history with Home -> Current Page
      window.history.replaceState(null, '', '/');
      window.history.pushState(null, '', path);
    }
    navigate(path);
  };
  return (
    <motion.div 
      className="min-h-screen pt-32 pb-20"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-5">
        <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-center min-h-[calc(100vh-8rem)]">
        <motion.div 
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <motion.h1 
            className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4"
            style={{ color: 'var(--color-primary-text)' }}
            whileHover={{ scale: 1.05 }}
          >
            Hi, I'm <span className="highlight">Adhiraj Jarwal</span>
          </motion.h1>
          
          <motion.h2 
            className="text-xl sm:text-2xl mb-6" 
            style={{ color: 'var(--color-primary-text)' }}
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Cloud Engineer & AWS Community Builder
          </motion.h2>
          
          <motion.p 
            className="text-base sm:text-lg mb-6 sm:mb-8 leading-relaxed" 
            style={{ color: 'var(--color-accent)' }}
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.4 }}
          >
            Specializing in AWS, Azure, Terraform, and DevOps automation. 
            Building scalable cloud infrastructure and contributing to the global AWS community.
          </motion.p>
          
          <motion.div 
            className="flex flex-col sm:flex-row gap-4 sm:gap-8 mb-6 sm:mb-8"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            <div className="flex items-center gap-2 text-sm sm:text-base font-semibold" style={{ color: 'var(--color-primary-text)' }}>
              <FaAws className="text-xl sm:text-2xl" style={{ color: 'var(--color-accent)' }} />
              <span>AWS Certified</span>
            </div>
            <div className="flex items-center gap-2 text-sm sm:text-base font-semibold" style={{ color: 'var(--color-primary-text)' }}>
              <SiGooglecloud className="text-xl sm:text-2xl" style={{ color: 'var(--color-accent)' }} />
              <span>GCP Certified</span>
            </div>
            <div className="flex items-center gap-2 text-sm sm:text-base font-semibold" style={{ color: 'var(--color-primary-text)' }}>
              <FaCloud className="text-xl sm:text-2xl" style={{ color: 'var(--color-accent)' }} />
              <span>Cloud Expert</span>
            </div>
          </motion.div>
          
          <motion.div 
            className="flex flex-col sm:flex-row gap-4 mb-8"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <a href="/Adhiraj-Jarwal.pdf" target="_blank" rel="noopener noreferrer" className="btn btn-primary">
              View Resume
            </a>
            <button onClick={() => handleNavigation('/contact')} className="btn btn-secondary">
              Get In Touch
            </button>
          </motion.div>
          
          <motion.div 
            className="flex gap-4"
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.7 }}
          >
            <a href="https://github.com/AdhiJarwal" target="_blank" rel="noopener noreferrer" className="text-2xl hover:-translate-y-1 transition-transform" style={{ color: 'var(--color-primary-text)' }}>
              <FaGithub />
            </a>
            <a href="https://linkedin.com/in/adjrwl" target="_blank" rel="noopener noreferrer" className="text-2xl hover:-translate-y-1 transition-transform" style={{ color: 'var(--color-primary-text)' }}>
              <FaLinkedin />
            </a>
            <a href="https://adhirajmjarwal.medium.com/" target="_blank" rel="noopener noreferrer" className="text-2xl hover:-translate-y-1 transition-transform" style={{ color: 'var(--color-primary-text)' }}>
              <FaMedium />
            </a>
          </motion.div>
        </motion.div>
        
        <motion.div 
          className="flex justify-center items-center"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4 }}
        >
          <motion.div 
            className="w-64 h-64 sm:w-80 sm:h-80 rounded-full overflow-hidden mx-auto"
            style={{ backgroundColor: 'var(--color-light-bg)' }}
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.3 }}
          >
            <img 
              src="/profile.jpg" 
              alt="Adhiraj Jarwal" 
              className="w-full h-full object-cover"
            />
          </motion.div>
        </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default Home;